<template>
  <div class="input-number-range" :style="{ width: width }">
    <div class="flex">
      <div class="from">
        <el-input
          ref="input_from"
          v-model="userInputForm"
          onkeyup="value=value.replace(/[^\d]/g,'')"
          placeholder="请输入"
          @input="handleInputFrom"
          :disabled="disabled"
        >
          <i slot="suffix">小时</i>
        </el-input>
      </div>
      <div class="to">
        <el-input
          ref="input_to"
          v-model="userInputTo"
          onkeyup="value=value.replace(/[^\d]/g,'')"
          maxlength="2"
          placeholder="请输入"
          @input="handleInputTo"
          :disabled="disabled"
        >
          <i slot="suffix">分钟</i>
        </el-input>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NfCoordinates',
  props: {
    userInputForm: {
      type: String,
      default: '',
    },
    userInputTo: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '283px',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {};
  },

  watch: {},

  methods: {
    handleInputTo(value) {
      if (value.replace(/[^\d]/g, '')) {
        if (Number(value.replace(/[^\d]/g, '')) > 59) {
          this.$message.error('请输入正确的时间格式');
          this.userInputTo = 0;
          this.$emit('inputTo', '0');
        } else {
          this.$emit('inputTo', this.userInputTo);
        }
      } else {
        this.$emit('inputTo', '');
      }
    },
    handleInputFrom(value) {
      this.$emit('inputFrom', value);
    },
    handleBlurFrom(event) {
      this.$emit('blurfrom', event);
    },

    handleFocusFrom(event) {
      this.$emit('focusfrom', event);
    },

    handleBlurTo(event) {
      this.$emit('blurto', event);
    },

    handleFocusTo(event) {
      this.$emit('focusto', event);
    },

    // from输入框change事件
    handleInputChangeFrom(value) {
      // 如果是非数字空返回null
      if (isNaN(value) || value === '') {
        this.$emit('input', [null, this.userInputTo]);
        this.$emit('changefrom', this.userInputForm);
        return;
      }

      // 初始化数字精度
      this.userInputForm = this.setPrecisionValue(value);

      // 如果from > to 将from值替换成to
      if (typeof this.userInputTo === 'number') {
        this.userInputForm =
          parseFloat(this.userInputForm) <= parseFloat(this.userInputTo)
            ? this.userInputForm
            : this.userInputTo;
      }
      this.$emit('input', [this.userInputForm, this.userInputTo]);
      this.$emit('changefrom', this.userInputForm);
    },

    // to输入框change事件
    handleInputChangeTo(value) {
      // 如果是非数字空返回null
      if (isNaN(value) || value === '') {
        this.$emit('input', [this.userInputForm, null]);
        this.$emit('changefrom', this.userInputTo);
        return;
      }

      // 初始化数字精度
      this.userInputTo = this.setPrecisionValue(value);

      if (typeof this.userInputForm === 'number') {
        this.userInputTo =
          parseFloat(this.userInputTo) >= parseFloat(this.userInputForm)
            ? this.userInputTo
            : this.userInputForm;
      }
      this.$emit('input', [this.userInputForm, this.userInputTo]);
      this.$emit('changeto', this.userInputTo);
    },
  },
};
</script>
<style lang="scss" scoped>
// 取消element原有的input框样式
::v-deep .el-input--mini .el-input__inner {
  border: 0px;
  margin: 0;
  padding: 0 15px;
  background-color: transparent;
}
.input-number-range {
  background-color: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
.flex {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  align-items: center;
  height: 31px;
  .center {
    margin-top: 1px;
  }
}
.is-disabled {
  background-color: #eef0f6;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
}
</style>
<style lang="scss">
.input-number-range {
  height: 33px !important;
  .el-input__inner {
    border: none !important;
    height: 30px !important;
  }
  .el-input__suffix {
    height: 32px !important;
    line-height: 32px !important;
    color: #181818 !important;
  }
}
</style>
